import { put, takeLatest } from "redux-saga/effects";
import axiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  selectAuthorityList: "[selectAuthorityList] Action",
  selectAuthorityListLoading: "[selectAuthorityListLoading] Action",
  selectAuthorityListAsync: "[selectAuthorityListync] Action"
};

const initialState = {
  data: [],
  size: 10,
  total: 0,
  loading: false
};

export const AuthorityList_select_reducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectAuthorityList:
      return {
        ...state,
        data: payload.results,
        total: payload.total
          ? payload.total > 10000
            ? 10000
            : payload.total
          : 0
      };
    case actionTypes.selectAuthorityListLoading:
      return {
        ...state,
        loading: payload
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({ type: actionTypes.selectAuthorityListLoading, payload: true });

  let config = {
    url: "select_request"
  };

  let data = {
    table: "portfolio",
    method_type: "options_of_instruments",
    data: payload.data ? payload.data : {},
    from: payload.from ? (payload.from - 1) * payload.size : 0,
    size: payload.size,
    sort_by: payload.sort_by
  };

  try {
    let res = yield axiosCustom(config, data);

    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) return;

    yield put({
      type: actionTypes.selectAuthorityList,
      payload: res.data.response.data
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({ type: actionTypes.selectAuthorityListLoading, payload: false });
  }
}

export function* AuthorityListSelect() {
  yield takeLatest(actionTypes.selectAuthorityListAsync, handleWorker);
}
